import {useState, useEffect} from 'react';
import {RoomMetricType} from "../../api/Constants";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import {toFSDateTime} from "../../util/timeutils";
import {Row, Select} from 'antd';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);


export const RoomChart = ({events}) => {
    const [sensor, setSensor] = useState("");
    const [options, setOptions] = useState([]);

    useEffect(() => {
        if ((events === undefined) || (events.length === 0)) {
            return;
        }
        // based on the events compute the options for the sensor selector
        const sensorMap = {};
        for (let i=0; i<events.length; i++) {
            const e = events[i];
            const {sensor, metric} = e;
            const metricLabel = RoomMetricType.Label[metric];
            const key = `${sensor}-${metricLabel}`
            if (sensorMap[key] === undefined) {
                sensorMap[key] = {
                    sensor,
                    metric: metricLabel
                }
            }
        }
        const nextOptions = Object.values(sensorMap).map((line, index) => {
            return {
                key: index,
                value: `${line.sensor}-${line.metric}`,
                label: `${line.sensor}-${line.metric}`
            }
        });

        setOptions(nextOptions);
        setSensor(nextOptions[0].value);
    }, [events]);

    if (events === undefined) {
        return <div />
    }

    const graphEvents = events.filter(row => (`${row.sensor}-${RoomMetricType.Label[row.metric]}` === sensor));
    const dataPoints = graphEvents.map(row => row.value);
    const labels = graphEvents.map(row => toFSDateTime(new Date(row.timestamp)));


    const data = {
        labels: labels,
        datasets: [{
            label: 'Data',
            data: dataPoints, //[65, 59, 80, 81, 56, 55, 40],
            fill: false,
            borderColor: 'rgb(75, 192, 192)',
            tension: 0.1
        }]
    };
    const graphOptions = {
        responsive: true,
        plugins: {
            title: {
                display: true,
                text: 'Line Chart',
            },
        },
    };

    const onMetricChange = (val) => {
        setSensor(val)
    }

    return <div>
        {(options.length > 0) && <Row>
            <Select options={options} placeholder={"metric"} onChange={onMetricChange} value={sensor} />
        </Row>}
        <Row>
            <Line options={graphOptions} data={data} />
        </Row>
    </div>
}